import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';
import { base16AteliersulphurpoolLight } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { PrismAsyncLight as SyntaxHighlighter } from 'react-syntax-highlighter';
import Typography from '../Typography';

const defaultRenderers = {
  /* eslint-disable react/prop-types */
  p: ({ children }) => <Typography className="mb-32">{children}</Typography>,
  table: ({ children }) => <table className="table table-bordered table-responsive">{children}</table>,
  pre: ({ children }) => <div>{children}</div>,
  tableCell: ({ children, isHeader }) => {
    if (isHeader) {
      if (children.length === 0) {
        return '';
      }
      return <th className="font-weight-medium">{children}</th>;
    }
    return <td className="font-weight-normal">{children}</td>;
  },
  code: props => {
    const { node, inline, className, components, children: codeChildren, ...codeRest } = props;
    return !inline ? (
      <SyntaxHighlighter
        showLineNumbers
        style={base16AteliersulphurpoolLight}
        language="graphql"
        PreTag="div"
        {...codeRest}
      >
        {codeChildren}
      </SyntaxHighlighter>
    ) : (
      <code className={className} {...props} />
    );
  },
  /* eslint-enable react/prop-types */
};

const Markdown = ({ components, children, ...rest }) => (
  <ReactMarkdown {...rest} plugins={[gfm]} components={{ ...defaultRenderers, ...components }}>
    {children}
  </ReactMarkdown>
);

Markdown.propTypes = {
  children: PropTypes.any.isRequired,
  components: PropTypes.object,
};

Markdown.defaultProps = {
  components: {},
};

export default Markdown;
